
import React from 'react';
import { Button } from '@/components/ui/button';
import { useQuickscan } from '@/contexts/QuickscanContext';
import { ArrowRight, Clock } from 'lucide-react';

const timeSlots = [
  { hour: 6, label: '6:00' },
  { hour: 8, label: '8:00' },
  { hour: 10, label: '10:00' },
  { hour: 12, label: '12:00' },
  { hour: 14, label: '14:00' },
  { hour: 16, label: '16:00' },
  { hour: 18, label: '18:00' },
  { hour: 20, label: '20:00' },
];

export const EnergyPeakScreen = () => {
  const { data, updateData, nextStep, prevStep } = useQuickscan();

  const toggleTimeSlot = (hour: number) => {
    const currentPeaks = [...data.energyPeakHours];
    const index = currentPeaks.indexOf(hour);
    
    if (index > -1) {
      currentPeaks.splice(index, 1);
    } else {
      currentPeaks.push(hour);
    }
    
    updateData('energyPeakHours', currentPeaks);
  };

  const getIntensity = (hour: number) => {
    if (data.energyPeakHours.includes(hour)) {
      return 'high';
    }
    return 'low';
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-energy-green mb-2">
          Wanneer gebruikt jouw bedrijf de meeste energie?
        </h2>
        <p className="text-gray-600">
          Selecteer de tijdstippen met het hoogste energieverbruik
        </p>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 mb-8">
        <div className="flex items-center mb-6">
          <Clock className="w-6 h-6 text-energy-blue mr-2" />
          <h3 className="text-lg font-semibold">Dagelijkse energiepieken</h3>
        </div>

        <div className="grid grid-cols-4 md:grid-cols-8 gap-3 mb-6">
          {timeSlots.map((slot) => {
            const isSelected = data.energyPeakHours.includes(slot.hour);
            const intensity = getIntensity(slot.hour);
            
            return (
              <button
                key={slot.hour}
                onClick={() => toggleTimeSlot(slot.hour)}
                className={`relative p-4 rounded-lg border-2 transition-all duration-200 ${
                  isSelected 
                    ? 'border-energy-orange bg-energy-orange text-white shadow-md' 
                    : 'border-gray-200 hover:border-energy-orange/50'
                }`}
              >
                <div className="text-center">
                  <div className="text-sm font-medium">{slot.label}</div>
                  {isSelected && (
                    <div className="mt-2">
                      <div className="w-full bg-white/20 rounded-full h-2">
                        <div className="w-full h-2 bg-white rounded-full animate-energy-pulse"></div>
                      </div>
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            {data.energyPeakHours.length} tijdslot(s) geselecteerd
          </p>
          {data.energyPeakHours.length > 0 && (
            <p className="text-sm text-energy-green mt-1">
              Uitstekend! Dit helpt ons om je energieopslagbehoeften in te schatten.
            </p>
          )}
        </div>
      </div>

      <div className="flex justify-between">
        <Button 
          variant="outline" 
          onClick={prevStep}
          className="border-gray-300"
        >
          Vorige
        </Button>
        
        <Button 
          onClick={nextStep}
          className="bg-[#014336] text-white hover:bg-[#014336]/90"
        >
          Volgende <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
};
